<template lang='pug'>
  v-layout(align-start='')
    v-flex.d-flex(style='min-height: 100%')
        v-col(cols='7' style='padding: 0')
            v-card.card-listado(style='padding: 0.5rem')
                v-card-title(style='padding-top: 0; padding-bottom: 0;')
                    v-row(style='align-items: baseline' dense)
                        v-text-field#searchProducto(
                            ref='searchProducto',
                            type='search',
                            v-model='searchProducto',
                            clearable,
                            outlined,
                            dense,
                            prepend-icon="mdi-package-variant",
                            placeholder='PRODUCTO',
                            @keyup.enter='addSearchProducto')
                        v-btn(color='success', rounded small, dark, style='margin-left: 1rem', @click='dialogProducto = true')
                            v-icon mdi-plus

                producto-m(
                    :dialog='dialogProducto'
                    :editedIndex='-1'
                    @close='dialogProducto = false '
                    @save='getProducto')

                v-divider
                v-card-text(style='flex: 1 1 auto; overflow:auto; height: 1px')
                    v-row(style='justify-content: space-around')
                        v-col(v-for='(producto, i) in filteredProductos', :key='i', cols='12', xs=12, sm=6,  md=3)
                            v-card.card-producto(class="mx-auto" @click='addProducto(producto)')
                                v-img(v-if='producto.idProducto.logo && producto.idProducto.logo !== "" ' :src='ruta + producto.idProducto.logo' alt="")
                                v-img(v-else src="../assets/no-img.jpg" alt="" height="200px")
                                v-card-text(style="font-size: .9rem")
                                  p(style='font-weight: bold') {{ producto.idProducto.descripcion}}
                                  p cod: {{ producto.idProducto.nombre}}
                                  p(v-if='producto.precio' style='color: #4CAF50') {{ producto.precio }} $
                                  p(v-if='producto.precioBs' style='color: #4CAF50') {{ producto.precioBs }} BsS
                v-divider
                v-card-actions
                  v-btn(color='teal darken-2', small, dark, @click='dialogAtajos = true')
                    v-icon mdi-information
                    | Atajos del Teclado

        // col cliente
        v-col(cols='5' style='background-color: blue; padding: 0')
            v-card.card-listado
                v-card-title(style='padding-bottom: 0')
                    v-row(style='align-items: baseline')
                      v-col(cols='12', style='padding-top: 0; padding-bottom: 0')
                        v-row(dense)
                          v-autocomplete#searchCliente(
                            autocomplete='off'
                            ref='searchCliente',
                            v-model='venta.idCliente',
                            outlined,
                            dense,
                            clearable,
                            prepend-icon="mdi-account",
                            placeholder='CLIENTE',
                            :items='clientes',
                            @keyup.enter='addCliente')
                          v-btn(color='success', rounded small, dark, style='margin-left: 1rem', @click='dialogCliente = true')
                              v-icon mdi-plus
                        v-row(dense, justify='space-between')
                          v-col(cols='6')
                            v-text-field(outlined, dense, label='Nombre', :value='venta.idCliente ? venta.idCliente.nombre : ""')
                          v-col(cols='5')
                            v-text-field(outlined, dense, label='Telefono', :value='venta.idCliente ? venta.idCliente.telefono : ""')
                        v-row(dense)
                          v-col(cols='12')
                            v-text-field(outlined, dense, label='Direccion', :value='venta.idCliente ? venta.idCliente.direccion : ""')

                cliente-m-pos(:dialog='dialogCliente' @close='dialogCliente = false' @save='setCliente')
                v-divider
                v-data-table.table-productos(
                    style='flex: 1 1 auto; overflow:auto; height: 1px',
                    :items-per-page='-1',
                    :headers='headers',
                    :items='productosCargados',
                    hide-default-footer,
                    no-data-text='AGREGA UN PRODUCTO')
                    template(v-slot:item.cantidadSolicitada='{ item }')
                        v-text-field(
                            v-model.number='item.cantidadSolicitada',
                            dense,
                            type='number',
                            min=1,
                            @input='changeCantidad(item)')
                    template(v-slot:item.action='{ item }')
                        v-tooltip(bottom='')
                            template(v-slot:activator='{ on }')
                                v-icon(color='error' @click='deleteProducto(item)' v-on="on") mdi-delete
                            | Eliminar
                v-divider
                v-card-actions(style='padding-top: 0; padding-bottom: 0')
                    v-col(cols='12', style='padding-top: 0; padding-bottom: 0')
                        v-row(style='width: 100%' dense)
                            v-col(cols='6')
                                p(class='montos-totales-text') SUBTOTAL
                                p(class='montos-totales-text') IVA
                                p(class='montos-totales-text') TOTAL
                            v-col(cols='6')
                                p(class='montos-totales-valor') {{ venta.subTotal }} BsS
                                p(class='montos-totales-valor') {{ venta.gravado }} BsS
                                p(class='monto-total') {{ venta.total }} BsS
                        v-row(style='width: 100%; justify-content: space-between' dense)
                            v-col(cols='6')
                              v-btn(style='width: 100%', color='error', @click='deleteAll') Eliminar Productos
                            v-col(cols='6')
                              v-btn(style='width: 100%; margin-bottom: 4px', color='success', @click='vender') Vender
                        //- v-row(style='width: 100%')
                v-dialog(v-model='dialogAtajos', max-width='40%')
                    v-card(color='grey_1')
                        v-app-bar(dark color='primary')
                            v-toolbar-title.headline Atajos
                        v-card-text
                            v-row(dense style='justify-content: center')
                                v-col(cols=12)
                                    .container-atajos
                                        ul
                                            li
                                                span ALT + C :
                                                | Agregar Cliente
                                            li
                                                span ALT + A:
                                                | Agregar Producto
                                            li
                                                span ALT + B:
                                                | Buscar Producto
                                            li
                                                span ALT + N:
                                                | Buscar Cliente
                                            li
                                                span ALT + E:
                                                | Borrar Productos
                                            li
                                                span ALT + V:
                                                | Vender
                v-dialog(v-model='dialog', scrollable, persistent, max-width='80%')
                    v-card(color='grey_1')
                        v-app-bar(dark color='primary')
                            v-toolbar-title.headline Facturar
                        v-divider(light)
                        v-card-text
                            v-row(dense)
                                v-col(cols='12')
                                    v-card(color='white')
                                        v-card-text
                                            v-row
                                                v-col(cols='12' xs='12' sm='6')
                                                    v-select(dense outlined v-model='venta.tipoVenta' :items='tipoVenta', label='Tipo de Venta')
                                                v-col(cols='12' xs='12' sm='6')
                                                    v-select(dense outlined, v-model='venta.formaPago', :items='formaPago', label='Forma de pago')
                                            v-row(style='justify-content: center')
                                                h1 TOTAL: {{ venta.total }}
                        v-card-actions
                            v-spacer
                            v-btn(color='error', small, dark, @click='dialog = false')
                                v-icon mdi-close
                                | Cancelar
                            v-btn(color='success', small, dark, @click='save')
                                v-icon mdi-content-save
                                | Facturar
</template>

<script>
import Api from '@/services/methods'
import ProductoM from '../components/modals/ProductoM'
import ClienteMPos from '../components/modals/ClienteMPos'
import { server, port } from '../services/environment'
export default {
  name: 'POS',
  components: {
    ProductoM,
    ClienteMPos
  },
  data: () => ({
    ruta: server + ':' + port,
    dialogAtajos: false,
    dialogProducto: false,
    dialogCliente: false,
    dialog: false,
    productosParaVenta: [],
    productosCargados: [],
    clientes: [],
    tipoVenta: ['Credito', 'Al Contado'],
    formaPago: ['Efectivo', 'Tarjeta', 'Transferencia', 'Otro'],
    searchProducto: null,
    venta: {
      detalleProducto: [],
      idCliente: null,
      tipoVenta: null,
      formaPago: null,
      unidadesVendidas: null,
      subTotal: 0,
      gravado: 0,
      exento: 0,
      total: 0,
      debito: 0,
      credito: 0,
      fechaVencimiento: null,
      observacion: null
    },
    headers: [
      { text: 'Producto', value: 'idProducto.descripcion', align: 'left', sortable: false },
      { text: 'Precio', value: 'precioBs', align: 'center', sortable: false },
      { text: 'Stock', value: 'cantidad', align: 'center', sortable: false },
      { text: 'Cantidad', value: 'cantidadSolicitada', align: 'center', sortable: false },
      { text: 'Total', value: 'total', align: 'center', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ]
  }),

  created () {
    this.initialize()
  },

  computed: {
    filteredProductos (val) {
      if (this.searchProducto === '' || !this.searchProducto) {
        return this.productosParaVenta
      } else {
        return this.productosParaVenta.filter(producto => producto.idProducto.descripcion.toLowerCase().includes(this.searchProducto.trim().toLowerCase()) || producto.idProducto.nombre.toLowerCase().includes(this.searchProducto.trim().toLowerCase()))
      }
    }
  },

  mounted () {
    window.addEventListener('keyup', (e) => {
      if (e.altKey) {
        switch (e.key.toLowerCase()) {
          case 'c':
            this.dialogCliente = true
            break
          case 'a':
            this.dialogProducto = true
            return null
          case 'b':
            return document.getElementById('searchProducto').focus()
          case 'n':
            return document.getElementById('searchCliente').focus()
          case 'e':
            return this.deleteAll()
          case 'v':
            return this.vender()
          default:
            return null
        }
      }
    })
  },

  methods: {
    initialize () {
      this.getProducto()
      this.getClientes()
    },

    getProducto () {
      Api.get('proalma/soloVenta')
        .then(response => {
          this.productosParaVenta = response.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    getClientes () {
      Api.get('cliente')
        .then(response => {
          response.data.forEach(cliente => {
            this.clientes.push({
              value: cliente,
              text: `${cliente.rif}`
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    setCliente (val) {
      this.getClientes()
      this.venta.idCliente = val
    },

    addSearchProducto () {
      console.log('entro we')
      let isAdd = true
      for (var i = 0; i < this.searchProducto.trim().length; i++) {
        // validacion si la cantidad introiducida es del formato *numoer (ej: *28)
        const char = this.searchProducto.trim().charAt(i)
        if (i === 0 && char !== '*') {
          isAdd = false
          break
        }
        if (i > 0 && isNaN(parseInt(char))) {
          isAdd = false
          break
        }
      }

      if (isAdd && this.productosCargados.length > 0) {
        const longitud = this.productosCargados.length
        this.productosCargados[longitud - 1].cantidadSolicitada = parseInt(this.searchProducto.trim().substr(1))
        this.searchProducto = ''
        this.actMontos()
      } else if (this.filteredProductos.length === 1) {
        this.addProducto(this.filteredProductos[0])
        this.searchProducto = ''
      }
    },

    addCliente () {
      if (!this.venta.idCliente || !this.venta.idCliente === '') {
        this.dialogCliente = true
      }
    },

    addProducto (producto) {
      const index = this.productosCargados.findIndex(p => p.idProducto._id === producto.idProducto._id)
      if (index === -1) {
        const cantidadSolicitada = 1

        let montos = {
          subTotal: producto.precioBs * cantidadSolicitada,
          baseImponible: 0,
          exento: 0,
          gravado: 0,
          porcDescuento: 0,
          total: 0
        }

        if (producto.idIva.valor > 0) {
          montos.gravado = Math.round(montos.subTotal * producto.idIva.valor * 100) / 100
          montos.total = Math.round((montos.gravado + montos.subTotal) * 100) / 100
          montos.baseImponible = montos.subTotal
        } else {
          montos.exento = montos.subTotal
          montos.total = montos.subTotal
        }

        this.productosCargados.push({
          ...producto,
          cantidadSolicitada,
          ...montos
        })
      } else {
        this.productosCargados[index].cantidadSolicitada += 1
        this.productosCargados[index].subTotal = this.productosCargados[index].cantidadSolicitada * this.productosCargados[index].precioBs
        if (producto.idIva.valor > 0) {
          this.productosCargados[index].gravado = Math.round(this.productosCargados[index].subTotal * producto.idIva.valor * 100) / 100
          this.productosCargados[index].total = Math.round((this.productosCargados[index].gravado + this.productosCargados[index].subTotal) * 100) / 100
          this.productosCargados[index].baseImponible = this.productosCargados[index].subTotal
        } else {
          this.productosCargados[index].exento = this.productosCargados[index].subTotal
          this.productosCargados[index].total = this.productosCargados[index].subTotal
        }
        console.log(this.productosCargados[index])
      }
      this.actMontos()
    },

    deleteProducto (producto) {
      const index = this.productosCargados.findIndex(p => p._id === producto._id)
      this.productosCargados.splice(index, 1)
      this.actMontos()
    },

    deleteAll () {
      this.productosCargados = []
      this.actMontos()
    },

    actMontos () {
      console.log(this.productosCargados)
      this.venta.subTotal = 0
      this.venta.gravado = 0
      this.venta.baseImponible = 0
      this.venta.exento = 0
      this.venta.total = 0
      if (this.productosCargados.length > 0) {
        this.productosCargados.forEach(producto => {
          this.venta.subTotal += producto.subTotal
          this.venta.subTotal = Math.round(this.venta.subTotal * 100) / 100
          if (producto.idIva.valor > 0) {
            this.venta.gravado += producto.gravado
            this.venta.gravado = Math.round(this.venta.gravado * 100) / 100
          } else {
            this.venta.exento += producto.exento
            this.venta.exento = Math.round(this.venta.exento * 100) / 10
          }
          this.venta.total += producto.total
          this.venta.total = Math.round(this.venta.total * 100) / 100
        })
      }
    },

    vender () {
      if (!this.venta.idCliente) {
        return this.$swal({
          icon: 'info',
          text: 'Debe seleccionar un cliente para continuar'
        })
      }
      if (this.productosCargados.length === 0) {
        return this.$swal({
          icon: 'info',
          text: 'Debe seleccionar al menos un producto para continuar'
        })
      }
      if (this.productosCargados.some(producto => producto.cantidad < producto.cantidadSolicitada)) {
        return this.$swal({
          icon: 'info',
          text: 'las cantidades no pueden ser mayor al stock'
        })
      }
      this.dialog = true
    },

    changeCantidad: function (producto) {
      const index = this.productosCargados.findIndex(p => p.idProducto._id === producto.idProducto._id)
      if (producto.cantidadSolicitada > 0) {
        this.productosCargados[index].cantidadSolicitada = producto.cantidadSolicitada
        this.productosCargados[index].subTotal = this.productosCargados[index].cantidadSolicitada * this.productosCargados[index].precioBs
        if (producto.idIva.valor > 0) {
          this.productosCargados[index].gravado = Math.round(this.productosCargados[index].subTotal * producto.idIva.valor * 100) / 100
          this.productosCargados[index].total = Math.round((this.productosCargados[index].gravado + this.productosCargados[index].subTotal) * 100) / 100
          this.productosCargados[index].baseImponible = this.productosCargados[index].subTotal
        } else {
          this.productosCargados[index].exento = this.productosCargados[index].subTotal
          this.productosCargados[index].total = this.productosCargados[index].subTotal
        }
        this.productosCargados = [...this.productosCargados]
        this.actMontos()
      } else {
        this.productosCargados[index].cantidadSolicitada = 0
      }
    },

    imprimirFactura (numFactura) {
      const cedula = this.venta.idCliente.rif.length === 11 ? this.venta.idCliente.rif.substr(2, 8) : this.venta.idCliente.rif.substr(2)
      const peticion = {
        cedula: cedula,
        nombre: this.venta.idCliente.nombre,
        direcion: this.venta.idCliente.direccion,
        numeroFactura: numFactura,
        unidadesVendidas: this.venta.detalleProducto.length === 1 ? this.venta.detalleProducto[0].cantidadSolicitada : this.venta.detalleProducto.reduce((a, b) => a.cantidadSolicitada + b.cantidadSolicitada),
        formaPago: this.venta.formaPago,
        condicionPago: this.venta.tipoVenta,
        productos: this.venta.detalleProducto.map(producto => {
          return {
            descripcion: producto.idProducto.descripcion,
            codigo: producto.idProducto.nombre,
            cantidad: parseFloat(producto.cantidadSolicitada),
            bsSinIVA: producto.subTotal || null,
            bsConIVA: producto.total || null,
            exento: producto.idIva.valor === 0,
            unidadMedida: producto.idProducto.unidadMedida?.descripcion
          }
        }),
        total: this.venta.total
      }

      this.$swal({
        title: 'Imprimiendo...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })

      // ruta para imprimir
      Api.get(`${this.$store.state.ipMaquina}`, peticion)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: 'Impresion exitosa'
          })
          // this.close()
          this.venta.idCliente = ''
          this.venta.formaPago = ''
          this.venta.tipoVenta = ''
          // this.initialize()
          this.deleteAll()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    save () {
      if (!this.venta.formaPago || !this.venta.tipoVenta) {
        return this.$swal({
          icon: 'error',
          text: 'Debe llenar ambos campos para continuar'
        })
      }

      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })

      this.venta.detalleProducto = [...this.productosCargados]
      Api.post('venta/minorista', this.venta)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: 'Inclusion exitosa',
            text: 'Todos los datos han sido guardados'
          })
          if (this.$store.state.ipMaquina !== '') {
            this.imprimirFactura(res.data.numFactura)
          } else {
            this.dialog = false
            this.venta.idCliente = ''
            this.venta.formaPago = ''
            this.venta.tipoVenta = ''
            this.deleteAll()
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    }
  }
}
</script>

<style lang='scss'>

.card-listado {
    display: flex !important;
    flex-direction: column !important;
    height: 100%;
    border-radius: 0 !important;
    -webkit-box-shadow: none;
    box-shadow: none;
    .v-text-field__details {
      display: none !important;
    }
}

.card-producto {
    &:hover {
        cursor: cell;
    }
}

.montos-totales-text {
  text-align: start;
  font-size: .9rem;
  margin-bottom: 0 !important;
}

.montos-totales-valor {
  text-align: center;
  font-size: .9rem;
  margin-bottom: 0 !important;
}

.monto-total {
  text-align: center;
  color: #4CAF50 ;
  font-size: .9rem;
}

.container-atajos {
    li {
        font-size: 1rem;
        span {
            font-weight: bold;
            margin-right: .5em;
        }
    }
}
</style>
